import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "content", "list", "view", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `operations--products--bookings--patients--dashboard`
  }

  doPatientsDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-7 pr-1" data-${this.controllerName}-target="list" data-controller="operations--products--bookings--patients--index"></div>
                  <div class="col-5 pl-1" data-${this.controllerName}-target="view" data-controller="operations--products--bookings--patients--show operations--products--bookings--patients--save"></div>
                </div>`
    this.getControllerByIdentifier("operations--products--bookings--entities--show").contentTarget.innerHTML = html
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
